import { renderModel } from '../../util/renderModel';

export const useIsSmallScreen = (): boolean => {
  // TODO revisit this when implementing layout for full page
  return renderModel.isMobile() || !renderModel.isFullWidth();
};
